import {Area, Branch} from '../master-data/master-data.model';
import {Chain} from '../chains/chains.model';


export const ADMIN_UUID = '9e2acdc8-82b1-4b68-88c0-6c8e1c4cc0f4';
export const BR_ADMIN_UUID = 'eaecde6a-99e1-49eb-915d-31682887b600';
export const CHAIN_ADMIN_UUID = '3754010c-fc2e-4283-858d-c22d2b273c62';
export const SYSTEM_ADMIN_UUID = 'bae0d4db-cd64-44ac-b883-2f2974a427d6';

export enum AdminType {
  BranchAdmin,
  ChainAdmin
}

export class Role {
  uuid: string;
  name: string;
  externalId?: string;
}


export interface SimpleUserDTO {
  uuid: string;
  name: string;
  phone: string;
  email: string;
  enabled: boolean;
}


export class Warehouse {
  uuid: string;
  name: string;
  externalId: string;
}


export class User {
  uuid: string;
  name: string;
  email: string;
  phone: string;
  roles?: Role[];
  area: Area;
  branch?: Branch;
  chains: Chain[];
  externalId?: string;
  firebaseUuuid?: string;
  crew?: SimpleUserDTO[];
  warehouse?: Warehouse | null;
  enabled: boolean;
  ignoreMfa?: boolean;
}


export interface ClientUuid {
  clientId: string;
  userId: string;
}


export interface CreateUserCommand {
  uuid?: string;
  name: string;
  areaUuid: string;
  phone: string;
  email: string;
  externalId: string;
  rolesUuid: string[];
  password?: string;
  warehouseUuid: string;
  branchUuid?: string;
  chainsUuids?: string[];
}

export interface ResetPasswordCommand {
  userUuid: string;
  password: string;
  manualSetPassword: boolean;
  logoutUser: boolean;
}

export interface ChangeUserBranchCommand {
  userUuid: string;
  branchUuid: string;
}

export class ChangeUserChainsCommand {
  userUuid: string;
  chainsUuids: string[];
}
